// Foreign language base names (without "dili" suffix)
export const FOREIGN_LANGUAGE_BASE_NAMES = ['İngilis', 'Rus', 'Alman', 'Fransız'];

// Foreign language full names (with "dili" suffix)
export const FOREIGN_LANGUAGE_FULL_NAMES = [
  'İngilis dili',
  'Rus dili',
  'Alman dili',
  'Fransız dili'
];

// Normalize foreign language name to base format
// Converts "Fransız dili" → "Fransız"
// Returns other names unchanged
export const normalizeForeignLanguage = (fenn: string): string => {
  const trimmed = fenn.trim();
  // Remove "dili" suffix if it's a foreign language
  if (FOREIGN_LANGUAGE_FULL_NAMES.includes(trimmed)) {
    return trimmed.replace(' dili', '');
  }
  return trimmed;
};

// Check if a subject is a foreign language
export const isForeignLanguage = (fenn: string): boolean => {
  return FOREIGN_LANGUAGE_FULL_NAMES.includes(fenn) ||
         FOREIGN_LANGUAGE_BASE_NAMES.includes(fenn.replace(/ dili$/i, ''));
};

// Add "dili" suffix to foreign language base name
// Converts "Fransız" → "Fransız dili"
// Returns other names unchanged
export const toFullForeignLanguageName = (baseName: string): string => {
  const trimmed = baseName.trim();
  if (FOREIGN_LANGUAGE_BASE_NAMES.includes(trimmed)) {
    return `${trimmed} dili`;
  }
  return trimmed;
};

// Get list of all Buraxılış subjects (for dropdowns and filters)
// Uses base names for foreign languages to match teacher.fenn format
export const getBuraxilisFenns = (): string[] => {
  return ['Azərbaycan dili', 'Riyaziyyat', ...FOREIGN_LANGUAGE_BASE_NAMES];
};

/** UI-da fənn adını həmişə tam formada göstərmək üçün: "Fransız" -> "Fransız dili" */
export const displayFenn = (fenn: string): string => {
  if (!fenn || typeof fenn !== 'string') return fenn || '';
  const t = fenn.trim();
  if (FOREIGN_LANGUAGE_BASE_NAMES.includes(t)) return toFullForeignLanguageName(t);
  return t;
};
